import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M677.680941,-0.0338823529 L677.680941,338.902588 L790.622118,338.902588 L790.622118,113.020235 L1807.09271,113.020235 L1807.09271,903.495529 L1581.09741,903.495529 L1581.09741,1163.26024 L1321.44565,903.495529 L1242.27388,903.495529 L1242.27388,451.843765 L677.680941,451.843765 L0.0338823529,451.843765 L0.0338823529,1468.31435 L338.744471,1468.31435 L338.744471,1887.21318 L756.739765,1468.31435 L1242.27388,1468.31435 L1242.27388,1016.43671 L1275.02682,1016.43671 L1694.15153,1435.56141 L1694.15153,1016.43671 L1920.03388,1016.43671 L1920.03388,-0.0338823529 L677.680941,-0.0338823529 Z M338.823529,903.529412 L903.529412,903.529412 L903.529412,790.588235 L338.823529,790.588235 L338.823529,903.529412 Z M338.823529,1129.41176 L677.76,1129.41176 L677.76,1016.35765 L338.823529,1016.35765 L338.823529,1129.41176 Z M112.975059,564.672 L1129.44565,564.672 L1129.44565,1355.37318 L710.433882,1355.37318 L451.685647,1615.02494 L451.685647,1355.37318 L112.975059,1355.37318 L112.975059,564.672 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconChatLine = /*#__PURE__*/function (_Component) {
  _inherits(IconChatLine, _Component);

  var _super = _createSuper(IconChatLine);

  function IconChatLine() {
    _classCallCheck(this, IconChatLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconChatLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconChat",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconChatLine.displayName = "IconChatLine";
  return IconChatLine;
}(Component);

IconChatLine.glyphName = 'chat';
IconChatLine.variant = 'Line';
IconChatLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconChatLine;
export { IconChatLine };